export default __webpack_public_path__ + "static/media/3_002.443fbcb5.png";